import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import { configApi } from '../api/configApi'
import { toAppConfigMap } from '../types/config'

export function useGetConfigs(fresh = false) {
  return useQuery({
    queryKey: ['configs'],
    queryFn: () => configApi.getConfigs(),
    select: data => toAppConfigMap(data),
    retry: false,
    refetchOnWindowFocus: false,
    staleTime: 5 * 60 * 1000,
    refetchOnMount: fresh ? 'always' : false,
  })
}

export function useGetConfig(id: string) {
  return useQuery({
    queryKey: ['configs', id],
    queryFn: () => configApi.getConfig(id),
    enabled: !!id,
  })
}

export function useCreateConfig() {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: configApi.createConfig,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['configs'] })
    },
  })
}

export function useUpdateConfig() {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: ({ payload }: { payload: Partial<any> }) => configApi.updateConfig(payload),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['configs'] })
    },
  })
}

export function useDeleteConfig() {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: (id: string) => configApi.deleteConfig(id),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['configs'] })
    },
  })
}
